const ConcurrencyManager = {
    currentVersion: '',
    taskId: 0,
    interval: null,
    isOutdated: false,
    init(taskId, initialVersionBase64) {
        if (!taskId || !initialVersionBase64) return;
        this.taskId = taskId;
        this.currentVersion = initialVersionBase64;
        this.isOutdated = false;
        this.startPolling();
    },

    startPolling() {
        this.interval = setInterval(() => this.checkVersion(), 20000);
    },

    async checkVersion() {
        const urlTemplate = window.appvars.services.assignments.checkversion;
        if (!urlTemplate) return;

        const url = urlTemplate.replace('{codFlowExecuteTask}', this.taskId)
            + '?taskVersionToCompare=' + encodeURIComponent(this.currentVersion);

        const afToken = document.querySelector("input[name=__RequestVerificationToken]");
        if (!afToken) return;

        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: new Headers({ 'X-SML-AntiForgeryToken': afToken.value })
            });

            if (!response.ok) return;

            const res = await response.json();
            if (res?.success?.isOutdated) {
                this.notifyUser();
            }
        } catch {
            // Erros de rede são ignorados silenciosamente para não interromper a experiência do usuário
        }
    },

    notifyUser() {
        if (this.isOutdated) return;

        this.isOutdated = true;
        this.stopPolling();

        if (typeof execv2 !== 'undefined' && execv2.hideControllerBlock) {
            execv2.hideControllerBlock();
        }

        if (typeof hideControllerBlock === 'function') {
            hideControllerBlock();
        }

        const saveBtn = document.querySelector('#ContainerForm > button[onclick*="save"]');
        if (saveBtn) saveBtn.style.visibility = 'hidden';

        const msg = globalThis.appvars?.translation?.concurrencyConflict;
        if (msg) globalThis.bsml.toast(msg, 'alert-warning');
    },

    restartWithVersion(newVersionBase64) {
        this.stopPolling();
        if (newVersionBase64) {
            this.currentVersion = newVersionBase64;
            this.isOutdated = false;

            const inp = document.querySelector('#inpRowVersion');
            if (inp) inp.value = newVersionBase64;

            if (this.taskId > 0) this.startPolling();
        }
    },

    stopPolling() {
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
        }
    }
};

globalThis.ConcurrencyManager = ConcurrencyManager;
